import { type DomainAccessControlConfig } from '../utils/domain/accessControl'
import { Permission } from './permissions'
import { FeatureToggle } from './featureToggles'

export const retailerFundedMarketingTargetingAccessControl: DomainAccessControlConfig = [
  {
    permissions: [
      Permission.RetailerFundedMarketingRetailerFundedMarketingViewAccess,
      Permission.RetailerFundedMarketingRetailerFundedMarketingModifyAccess,
    ],
    restrictedBannersAllowed: true,
  },
]

// Union of targeting (router) and home (domainDef) permission sets for segmentation routes
export const retailerFundedMarketingSegmentationAccessControl: DomainAccessControlConfig = {
  permissions: [
    Permission.RetailerFundedMarketingRetailerFundedMarketingViewAccess,
    Permission.RetailerFundedMarketingRetailerFundedMarketingModifyAccess,
    Permission.RetailerFundedMarketingRetailerFundedMarketingInsights,
  ],
  restrictedBannersAllowed: true,
  notFeatureToggles: [FeatureToggle.retailerFundedMarketingUserDenyList],
}
